import { categoryForSale } from "../tasks/taskUtils";
import type { Sale, Task, ZoomMeetingSummary } from "../types";

export type PlaneDraftState = "hidden" | "push" | "go";

// What a meeting's task row shows about Plane. LCCRM-92.
//
// `go` means the task is already in Plane, wherever it was pushed from. `push`
// follows the rule every other surface uses: only a Dev task can be pushed for
// the first time. A draft that is not a task yet has no category of its own, so
// it counts as Dev when its assignee's role is, which is the category
// buildTaskRow will give it on confirm.
export const planeDraftState = ({
  draft,
  task,
  sales,
}: {
  draft: Pick<ZoomMeetingSummary["tasks"][number], "task_id" | "sales_id">;
  // The real task behind a confirmed draft. Undefined while it loads, and when
  // the task has since been deleted.
  task?: Pick<Task, "category" | "plane_issue_id">;
  sales?: Pick<Sale, "id" | "role">[];
}): PlaneDraftState => {
  if (draft.task_id == null) {
    return categoryForSale(draft.sales_id, sales, "follow-up") === "dev"
      ? "push"
      : "hidden";
  }
  if (!task) return "hidden";
  if (task.plane_issue_id) return "go";
  return task.category === "dev" ? "push" : "hidden";
};
